(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("no-data-elimination", [], factory);
	else if(typeof exports === 'object')
		exports["no-data-elimination"] = factory();
	else
		root["no-data-elimination"] = factory();
})(self, function() {
return 